export interface ISelectedRow {
    selectedRowId   : string | number | null;
}